import React from 'react';
import { ReactComponent as Android1 } from "../../assets/image/svg/android1.svg";
import { ReactComponent as Android2 } from "../../assets/image/svg/android2.svg";
import { ReactComponent as Android3 } from "../../assets/image/svg/android3.svg";
import { PhoneFrame, Overlay } from './index';

function AndroidInstallScreen1({ whiteLabel }) {
  return (
    <PhoneFrame Svg={Android1}>
      <div className="android-step1-content">
        <img src={whiteLabel?.mobile_logo} className="logo" />
        <span style={{ fontSize: 'clamp(18px, 2vw, 22px)', fontWeight: 600 }}>
          {whiteLabel?.company_name || "Move2Order"}
        </span>
      </div>
    </PhoneFrame>
  );
}

function AndroidInstallScreen2({ whiteLabel }) {
  const SVG_W = 420;
  const SVG_H = 900;
  const X = 60;
  const Y = 360;
  return (
    <PhoneFrame Svg={Android2}>
      <Overlay x={X} y={Y} svgW={SVG_W} svgH={SVG_H}>
        <div className="android-step2-content">
          <div className="logo-box rounded-6" style={{ width: "clamp(32px, 8%, 50px)", height: "clamp(32px, 8%, 50px)", minWidth: "32px", minHeight: "32px", flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src={whiteLabel?.mobile_logo}
              alt="logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div className="step-title" style={{ fontSize: 'clamp(11px, 1.3vw, 15px)' }}>
              {whiteLabel?.company_name || "Move2Order"}
            </div>
            <div className="step-domain" style={{ fontSize: 'clamp(9px, 1vw, 12px)', width: 'auto', maxWidth: '100%' }}>
              {whiteLabel?.domain || "move2order.com"}
            </div>
          </div>
        </div>
      </Overlay>
    </PhoneFrame>
  );
}

function AndroidInstallScreen3({ whiteLabel }) {
  const SVG_W = 420;
  const SVG_H = 915;
  return (
    <PhoneFrame Svg={Android3}>
      <Overlay
        y={600}
        svgW={SVG_W}
        svgH={SVG_H}
        centerX
      >
        <div className="android-step3-content">
          <div className="logo-box rounded-8" style={{ width: "clamp(28px, 35%, 70px)", height: "clamp(28px, 35%, 70px)", background: "#fff" }}>
            <img
              src={whiteLabel?.mobile_logo}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          <span className="step-title" style={{ fontSize: 'clamp(12px, 1vw, 15px)', fontWeight: 500,  maxWidth: '100%', textAlign: 'center', overflowWrap: 'break-word', wordBreak: 'break-word', lineHeight: '1.2', backgroundColor:'#fff' }}>
            {whiteLabel?.company_name || "Move2Order"}
          </span>
        </div>
      </Overlay>
    </PhoneFrame>
  );
}
export const androidSteps = [
  {
    title: '1.',
    description: 'Click on the install button or on the add to home screen banner.',
    content: AndroidInstallScreen1,
  },
  {
    title: '2.',
    description: 'Click on "Install"',
    content: AndroidInstallScreen2,
  },
  {
    title: '3.',
    description: 'Click on "Add"',
    content: AndroidInstallScreen3,
  },
];
